var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ed-title-nav',{attrs:{"title":_vm.$t('Products'),"subtitle":_vm.$t('Manage Products'),"tabs":_vm.tabs}}),_vm._v(" "),_c('legacy-container',{attrs:{"url":_vm.url}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14067d28","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Products/Products.vue
// module id = obo4
// module chunks = 12